import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  z-index: 1;
  margin: auto;
  padding: 3rem;
  border-radius: 1.5rem;
`